
class ActionModel {
    type:string;
    amplitude:number;
    offset:number;
    init:number|null;

    constructor(type:string, amplitude:number, offset = 0, init = null) {
        this.type = type;
        this.amplitude = amplitude;
        this.offset = offset;
        this.init = init;
    }
}

export default ActionModel
